// @ts-ignore
import sanitizeHtml from 'sanitize-html'

const sanitizeBrandHtmlContent = (description: string): string => {
    if (!description) {
        return ''
    }

    return sanitizeHtml(description, {
        allowTags: [
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'p',
            'span',
            'b',
            'i',
            'em',
            'strong',
            'a',
            'ol',
            'ul',
            'li',
            'sub',
            'sup',
        ],
        allowedAttributes: {
            a: ['href', 'target'],
            p: ['style'],
        },
        allowedSchemes: ['http', 'https', 'mailto', 'tel'],
        allowedSchemesAppliedToAttributes: ['href'],
        disallowedTagsMode: 'discard',
    })
}

export default sanitizeBrandHtmlContent
